import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({ 
  title = "Compositeur | Ingénieur Son Tournage & Post-Production",
  description = "Compositeur de musiques de films (Max et Léon, Les Vedettes, Bonne Conduite) et séries TV (Palmashow). Plus de 15 ans d'expérience en composition musicale et post-production audio.",
  keywords = "compositeur, musique de film, technicien son, post-production audio, Palmashow, Max et Léon, Les Vedettes, composition musicale, bande originale",
  image = "https://www.charlesludig.com/images/charles-preview.jpg",
  url = "https://www.charlesludig.com",
  type = "website"
}) => {
  // Force la mise à jour du titre même si Helmet ne se déclenche pas
  useEffect(() => {
    document.title = title;
  }, [title]);

  return (
    <Helmet>
      {/* Métadonnées de base */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph (Facebook, LinkedIn) */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Charles Ludig" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Informations supplémentaires */}
      <meta name="author" content="Charles Ludig" />
      <link rel="canonical" href={url} />
      
      {/* Langue */}
      <html lang="fr" />
    </Helmet>
  );
};

export default SEO;